<template>
  <div class="main__section">
    <h1 class="section__title">
      {{ $t('triggers') }} -> {{ $t('trigger-mailings') }} -> {{ $t('history-sending') }}
    </h1>
    <div class="main__body">
      <table class="table table-striped">
        <thead>
        <tr>
          <th scope="col">№</th>
          <th scope="col">{{ $t('name-triggers') }}</th>
          <th :class="{active: isActiveDate}" scope="col" class="order pointer" @click="sortDate()">{{ $t('date-sending') }}</th>
          <th scope="col">{{ $t('time') }}</th>
          <th scope="col"></th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, index) in triggerMessageHistory" v-bind:key="item.id">
          <th scope="row">
            {{ index + 1}}
          </th>
          <td>{{ item.name }}</td>
          <td>{{ item.date_send.split(' ')[0] }}</td>
          <td>{{ item.date_send.split(' ')[1] }}</td>
          <td><a class="link" @click="unloadClient(item.id, item.date_send)">{{ $t('unload-clients') }}</a></td>
        </tr>
        </tbody>
      </table>
    </div>
    <loading :active.sync="isLoading"
             :can-cancel="true"
             :is-full-page="fullPage"></loading>
  </div>
</template>

<script>

import axios from "axios";
import loading from "vue-loading-overlay";
import clientInSegmentModal from "../components/modal/clientInSegmentModal";

export default {
  name: 'historyTriggerMessage',
  data: function () {
    return {
      isActiveDate: false,
      triggerMessageHistory: [],
      data: {
        id: this.$route.params.id,
        date: 'ASC'
      },
      isLoading: false,
      fullPage: true,
    }
  },
  created: function () {
    this.getTriggerMessageHistory();
  },
  methods: {
    sortDate: function(){
      if(this.isActiveDate){
        this.isActiveDate = false;
        this.data.date = 'ASC';
        this.getTriggerMessageHistory();
      }else{
        this.isActiveDate = true;
        this.data.date = 'DESC';
        this.getTriggerMessageHistory();
      }
    },
    unloadClient: function (id, date){
      this.isLoading = true;
      var data = {
        trigger_id: id,
        date: date,
      }

      axios.post('unloadTriggerMessageHistory', data).then(response => {
        var status = response.data.status;
        if(status){
          this.isLoading = false;
          let link = document.createElement('a');
          link.href = response.data.link;
          link.setAttribute('download', response.data.filename);
          document.body.appendChild(link);
          link.click();
          link.remove();
        }
      });
    },
    getTriggerMessageHistory: function () {
      this.isLoading = true;
      axios.post('getTriggerMessageHistory', this.data).then(response => {
        var status = response.data.status;
        if(status){
          this.triggerMessageHistory = response.data.triggerMessageHistory;
          this.isLoading = false;
        }
      });
    },
  },
  components: {
    loading, clientInSegmentModal
  }
}
</script>